import template from 'carousel-slider/shadow-zoom.j2';

// eslint-disable-next-line no-unused-vars
import panzoom from 'jquery.panzoom';

import { generate } from '../../../core/js/utils/componentUtils';
import { shadowZoomSwiperInit } from '../utils/swiperInits';
import { unveilImages } from '../../../core/js/uiSupport/unveil';
import {
    isTabPressed,
    isEscPressed,
    isSpacePressed
} from '../../../core/js/utils/keyUtils';
import {
    PLUSKEY,
    MINUSKEY,
    DOWNKEY,
    ESCKEY,
    LEFTKEY,
    RIGHTKEY,
    UPKEY
} from '../../../core/js/enums/keyEnums';

// large variables
const largeZoomSelector = '.js-zoom';
const largeZoomImgSelector = '.js-zoom__img';

// this should be half the width/height of the hover box
const zoomOverlaySelector = '.js-zoom-overlay';
const zoomOverlayImageSelector = '.js-zoom-overlay__img';
const zoomOverlayHiddenClass = 'c-zoom-overlay--hidden';
const zoomScene7ImageSize = '$redesign-zoom-5x$';
const zoomCloseButton = '.js-shadow-zoom__close-zoom';

const pdpMetaElementsThatFadeOut = [
    '.c-product-meta',
    '.c-product-reviews__outer',
    '.c-product-colors',
    '.c-product-sizes',
    '.c-product-quantity',
    '.c-product-bopis',
    '.c-product-add-to-cart__button',
    '.o-list-swatches__swatch',
    '.c-product-sku-actions'
];

const bodyClass = 'has-modal-open';

let halfOverlayWidth = 0;
let halfOverlayHeight = 0;
const zoomImgWidth = 1450;
const zoomImgHeight = 2175;

const browserSizes = {
    'extra-small': 567,
    'small': 640,
    'medium': 768,
    'large': 1025,
    'extra-large': 1441
};

// small variables
const panzoomSelector = '.js-shadow-zoom--product-image .js-zoom-product-image';
let tapTimer = null;

// begin Small functions

/**
 * Hides the zoom overlay instructions
 * @return     {undefined}
 */
function hideZoomOverlayInstructions() {
    $('.js-overlay-instructions').addClass('c-zoom-overlay__instructions--hidden');
}

/**
 * Turns on meta viewport pinch and pull for small zoom
 * @return     {undefined}
 */
function enableMetaPinchAndPull() {
    // activate pinch / pull
    $('meta[name=viewport]')
        .attr('content', 'width=device-width, initial-scale=1.0, maximum-scale=4.0, user-scalable=yes');
}

/**
 * Turns off small zoom mode
 * @param      {object}   e    Event
 * @return     {undefined}
 */
function deactivateZoomMode(e) {
    // Hide zoom swiper
    $(this.scopedSelector())
        .removeClass('o-shadow-zoom__open js-shadow-zoom__open');

    // Unbind custom events
    $(zoomCloseButton).off();
    $('.dom-shadow-zoom .js-shadow-zoom__button--next').off();
    $('.dom-shadow-zoom .js-shadow-zoom__button--prev').off();

    // Reset and destroy the panzoom so our images behave normally
    $(panzoomSelector).panzoom('reset');
    $(panzoomSelector).panzoom('destroy');
    $(panzoomSelector).off('panzoomend');

    // Allow user to pinch and pull again
    enableMetaPinchAndPull();

    $(document.body).removeClass(bodyClass);
    $(this.originatingElement).focus();
    $('html, body').animate({
        scrollTop: this.originatingScrollOffset
    }, 100);

    // Remove space to close event
    $(document).off(`keyup.${this.name}`);
}

/**
 * Turns off meta viewport pinch and pull for small zoom
 * @return     {undefined}
 */
function disableMetaPinchAndPull() {
    // Freeze pinch/pull
    $('meta[name=viewport]')
        .attr('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=yes');
}

export function getZoomImage(idx, component, scopeClass = 'js-carousel-zoom__inner') {
    let images;

    if (isNaN(idx)) {
        images = $(`.${scopeClass} .js-carousel-zoom__slide img.js-lazy`);
    } else {
        images = $(`.${scopeClass} .js-carousel-zoom__slide[data-swiper-slide-index=${idx}] img.js-lazy`);
    }
    if (images.length > 0) {
        // if this is the last image, there will be 2 images selected because the swiper wraps the images in the carousel
        // so always take the last one (which is the one we are about to show)
        const img = $(_.last(images));

        if ($(img).attr('src') === $(img).attr('data-src')) {
            this.removeLoader();
        } else {
            img.load(() => {
                this.removeLoader();
            });
            $.each(images, (i, val) => {
                $(val).attr('src', $(val).attr('data-src'));
            });
        }
    } else {
        this.removeLoader();
    }
}

function initShadowZoom() {
    const initialSlide = parseInt($(`${this.relatedLocation} .swiper-slide-active`)
        .attr('data-swiper-slide-index'), 10);
    const slideCount = $(this.scopedSelector('.js-carousel-zoom__inner--shadow-zoom')).children().length;

    shadowZoomSwiperInit.bind(this)(slideCount, initialSlide, panzoomSelector, getZoomImage);
}

/**
 * Turns on Small Zoom Mode
 * @param      {object}   e    Event
 * @return     {undefined}
 */
function activateZoomMode(e) {
    this.originatingElement = _.get(e, 'target') || document.activeElement;
    this.originatingScrollOffset = $(window).scrollTop();
    $(document.body).addClass(bodyClass);

    $(this.scopedSelector()).addClass('o-shadow-zoom__open js-shadow-zoom__open');
    $('.js-overlay-instructions').removeClass('c-zoom-overlay__instructions--hidden');

    // init swiper on shadow zoom dom
    const initialSlide = parseInt($(`${this.relatedLocation} .swiper-slide-active`)
        .attr('data-swiper-slide-index'), 10);
    const slideCount = $(this.scopedSelector('.js-carousel-zoom__inner--shadow-zoom')).children().length;
    const mainSwiper = $('.js-main-carousel .js-carousel-zoom--product-image')[0].swiper;

    // Destroy old shadow zoom
    const oldShadowZoom = $(this.scopedSelector('.js-shadow-zoom--product-image'));

    if (_.get(oldShadowZoom, '0.swiper')) {
        oldShadowZoom[0].swiper.destroy(true, true);
    }

    shadowZoomSwiperInit.bind(this)(slideCount, initialSlide, panzoomSelector, getZoomImage);

    // Grab clicks on close X guy in the corner, kill zoom mode
    $(this.scopedSelector(zoomCloseButton)).on('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        deactivateZoomMode.bind(this)(event);
    });

    // prevent user from tabbing past close button
    $(this.scopedSelector(zoomCloseButton)).on('keydown', (event) => {
        if (isTabPressed(event) && !event.shiftKey) {
            event.preventDefault();
        }

        if (isSpacePressed(event) || isEscPressed(event)) {
            event.preventDefault();
            deactivateZoomMode.bind(this)(e);
        }
    });
    // Bind next and previous click events to reset zoom
    $(this.scopedSelector('.js-shadow-zoom__button--next')).on('click', (event) => {
        $(panzoomSelector).panzoom('reset', {
            animate: true,
            silent: true
        });
        $(panzoomSelector).css('cursor', 'default');
        mainSwiper.slideNext();
        const previousCarousel = $(mainSwiper.slides[mainSwiper.previousIndex]);
        $(previousCarousel.find('.js-zoom-product-image')).attr('tabindex', '-1');
    });
    // prevent user from tabbing before next button
    $(this.scopedSelector('.js-shadow-zoom__button--next')).on('keydown', (event) => {
        if (isTabPressed(event) && event.shiftKey) {
            event.preventDefault();
        }
    });
    $(this.scopedSelector('.js-shadow-zoom__button--next')).focus();

    $(this.scopedSelector('.js-shadow-zoom__button--prev')).on('click', (event) => {
        $(panzoomSelector).panzoom('reset', {
            animate: true,
            silent: true
        });
        $(panzoomSelector).css('cursor', 'default');
        mainSwiper.slidePrev();
        const previousCarousel = $(mainSwiper.slides[mainSwiper.previousIndex]);
        $(previousCarousel.find('.js-zoom-product-image')).attr('tabindex', '-1');
    });

    $(this.scopedSelector('.js-overlay-instructions')).on('click', (event) => {
        // Zoom In click of indictator
        hideZoomOverlayInstructions();
        $(panzoomSelector).panzoom('zoom', { silent: true });
        $(panzoomSelector).css({ 'cursor': '-webkit-grab' });
    });

    // Don't allow user to pinch and pull till zoom mode goes away
    disableMetaPinchAndPull();

    // Turn on Panzoom, which allows users to pinch pull and drag
    let panzoomOptions;

    if (_.isFunction(this.zoomOptions)) {
        panzoomOptions = this.zoomOptions();
    } else {
        panzoomOptions = this.zoomOptions;
    }

    $(panzoomSelector).panzoom(panzoomOptions);

    // Bind logic to zoom or not zoom and add double click zoom logic
    // eslint-disable-next-line no-shadow
    $(panzoomSelector).on('panzoomend', (event, panzoom, matrix, changed) => {
        if (tapTimer === null) {
            // start single click / tap timer
            tapTimer = setTimeout(() => {
                tapTimer = null;

                // execute if no double tap is detected
                if (changed) {
                    $(panzoomSelector).css({ 'cursor': '-webkit-grab' });
                }
            }, 300);
        } else {
            clearTimeout(tapTimer);
            tapTimer = null;

            hideZoomOverlayInstructions();

            // Zoom In on double tap
            $(panzoomSelector).panzoom('zoom', { silent: true });
            $(panzoomSelector).css({ 'cursor': '-webkit-grab' });
        }
    });
}

// end small functions

// Start Large functions

/**
 * Set overlay to match screen size
 * @param      {integer}   width    width of overlay
 * @param      {integer}   height   height of overlay
 * @return     {undefined}
 */
function resetOverlaySizes(width, height) {
    halfOverlayWidth = width / 2;
    halfOverlayHeight = height / 2;
}

/**
 * Scales the overlay image (on main PDP image) to be proper
 * based on the current size of the main PDP image.
 *  @param      {object}   e    Event
 */
function scaleOverlayImage(e) {
    const currentWidth = window.innerWidth;

    if (currentWidth >= this.largeBreakpoint) {
        const zoomImgOverlayWidth = $(`.js-zoom`).width();
        const zoomImgOverlayHeight = $(`.js-zoom`).height();
        const mainImgWidth = $(`${this.relatedLocation} .js-zoom-product-image:visible`).width();
        const mainImgHeight = $(`${this.relatedLocation} .js-zoom-product-image:visible`).height();
        const widthPercent = zoomImgOverlayWidth / zoomImgWidth;
        const heightPercent = zoomImgOverlayHeight / zoomImgHeight;
        const mainOverlayWidth = Math.round(mainImgWidth * widthPercent);
        const mainOverlayHeight = Math.round(mainImgHeight * heightPercent);

        // After math set overlay size
        $(`${this.relatedLocation} .js-zoom-overlay`).width(mainOverlayWidth);
        $(`${this.relatedLocation} .js-zoom-overlay`).height(mainOverlayHeight);

        // Set some global sizes based on the new overlay size
        resetOverlaySizes.bind(this)(mainOverlayWidth, mainOverlayHeight);
    }
}

/**
 * The crosshair background image has to be set to the proper (scaled) width and height.
 * @param      {object}   e    Event
 * @return     {undefined}
 */
function setHoverOverlaySizes(e) {
    const clientWidth = e.target.clientWidth;
    const clientHeight = e.target.clientHeight;

    $(zoomOverlayImageSelector).css('width', clientWidth);
    $(zoomOverlayImageSelector).css('height', clientHeight);
}

/**
 * Handle positioning of large zoom hover when mouse is moved
 * @param      {int}   x        Distance mouse is offset on x axis
 * @param      {int}   y        Distance mouse is offset on y axis
 * @param      {int}   width    Width of image
 * @param      {int}   height   Height of image
 * @return     {undefined}
 */
function handleLargeZoomHoverMovement(x, y, width, height) {
    // Find out where the corner of the over lay is, and then figure out what % it is across the main image
    const overlayTopLeftX = (x - halfOverlayWidth) / width;
    const overlayTopLeftY = (y - halfOverlayHeight) / height;

    // Use the above percent to figure out where to position the zoom image
    let zoomLeft = overlayTopLeftX * zoomImgWidth;
    let zoomTop = overlayTopLeftY * zoomImgHeight;

    // Negate it because CSS is crazy
    zoomLeft = zoomLeft * -1;
    zoomTop = zoomTop * -1;

    // Apply that jawn to the large Zoom Img CSS
    $(largeZoomImgSelector).css({
        'left': `${zoomLeft}px`,
        'top': `${zoomTop}px`
    });
}

/**
 * Handle positioning of large zoom hover overlay when mouse is moved
 * @param      {int}   mouseXCoordinate        Distance mouse is offset on x axis
 * @param      {int}   mouseYCoordinate        Distance mouse is offset on y axis
 * @return     {undefined}
 */
function handleLargeZoomOverlayMovement(mouseXCoordinate, mouseYCoordinate) {
    // Move the location of the image being display
    $(zoomOverlaySelector).css('left', mouseXCoordinate - halfOverlayWidth);
    $(zoomOverlaySelector).css('top', mouseYCoordinate - halfOverlayHeight);

    // Inside the location being displayed, move that image negative so it matches up
    $(zoomOverlayImageSelector).css('left', mouseXCoordinate * -1 + halfOverlayWidth);
    $(zoomOverlayImageSelector).css('top', mouseYCoordinate * -1 + halfOverlayHeight);
}

/**
 * Handle large zoom hover-movement
 * @param      {object}   e    Event
 * @return     {undefined}
 */
function largeZoomMove(e) {
    // Get location of element
    const offset = $(this).offset();
    const width = $(this).width();
    const height = $(this).height();

    let x = e.pageX - offset.left;
    let y = e.pageY - offset.top;

    // When mouse scrolls near the edge, keep the overlay and zoom from going out of bounds
    if (x - halfOverlayWidth < 0) {
        x = halfOverlayWidth;
    } else if (x + halfOverlayWidth > width) {
        x = width - halfOverlayWidth;
    }

    if (y - halfOverlayHeight < 0) {
        y = halfOverlayHeight;
    } else if (y + halfOverlayHeight > height) {
        y = height - halfOverlayHeight;
    }

    // handle movement of right zoomed-in image
    handleLargeZoomHoverMovement(x, y, width, height);

    // handle movement of left smaller hover overlay image guy
    handleLargeZoomOverlayMovement(x, y);
}

/**
 * Make background opaque so fadein occurs properly
 * @return     {undefined}
 */
function hideProductMeta() {
    for (let i = 0; i < pdpMetaElementsThatFadeOut.length; i++) {
        $(pdpMetaElementsThatFadeOut[i]).addClass('is-opaque');
    }
}

/**
 * displays zoom div with image on right side of PDP
 * @param      {object}   e    Event
 * @return     {undefined}
 */
function showLargeZoomImage(e) {
    // Fill zoom div with hover'd img
    let src = e.target.src;

    src = src.substring(0, src.indexOf('$')) + zoomScene7ImageSize;

    // Set the background of the img to be the current zoom image
    $(largeZoomImgSelector).attr('src', src);

    // Hide the meta
    hideProductMeta();

    // turn off transition that was previously set using jquery's .on()
    $(largeZoomSelector).off('transitionend');

    // Handle the fadein.  Since we have to adjust opacity and display:none, we have to manage them separately
    $(largeZoomSelector).removeClass('is-hidden');

    setTimeout(() => {
        $(largeZoomSelector).removeClass('is-visually-hidden');
    }, 20);
}

/**
 * Create overlay image cursor thing on left side of PDP
 * @param      {object}   e    Event
 * @return     {undefined}
 */
function showLargeZoomHoverOverlay(e) {
    $(zoomOverlaySelector).removeClass(zoomOverlayHiddenClass);
}

/**
 * Handle Large zoom start
 * displays zoom div with image
 * @param      {object}   e    Event
 * @return     {undefined}
 */
function largeZoomStart(e) {
    setHoverOverlaySizes(e);

    $(this).on('mousemove', largeZoomMove);

    showLargeZoomImage(e);

    showLargeZoomHoverOverlay(e);
}

/**
 * Make background opaque so fadein occurs properly
 * @return     {undefined}
 */
function showProductMeta() {
    for (let i = 0; i < pdpMetaElementsThatFadeOut.length; i++) {
        $(pdpMetaElementsThatFadeOut[i]).removeClass('is-opaque');
    }
}

/**
 * Handle hiding the large zoom object
 * @return     {undefined}
 */
function hideLargeZoom() {
    // Reset classes all at once to handle fast mousing over and out
    $(largeZoomSelector).addClass('is-visually-hidden');
    $(largeZoomSelector).addClass('is-hidden');

    // display product meta back at full opacity
    showProductMeta();
}

/**
 * Handle large zoom end
 * Hides zoom window
 * @param      {object}   e    Event
 * @return     {undefined}
 */
function largeZoomEnd(e) {
    hideLargeZoom();

    $(zoomOverlaySelector).addClass(zoomOverlayHiddenClass);

    $(this).off('mousemove', largeZoomMove);
}

// end Large functions

function attachKeyboardEvents() {
    $(document).on('keydown', `${this.relatedLocation}`, (e) => {
        handleKeySwitch.bind(this)(e);
    });
}

function handleKeySwitch(e) {
    switch (e.keyCode) {
        case ESCKEY:
            e.preventDefault();
            deactivateZoomMode.bind(this)(e);
            break;
        case PLUSKEY:
            e.preventDefault();
            hideZoomOverlayInstructions();
            $(panzoomSelector).panzoom('zoom', { silent: true });
            $(panzoomSelector).css({ 'cursor': '-webkit-grab' });
            break;
        case MINUSKEY:
            e.preventDefault();
            $(panzoomSelector).panzoom("reset");
            break;
        case UPKEY:
            e.preventDefault();
            $(panzoomSelector).panzoom("pan", 0, 10, { relative: true });
            break;
        case DOWNKEY:
            e.preventDefault();
            $(panzoomSelector).panzoom("pan", 0, -10, { relative: true });
            break;
        case LEFTKEY:
            e.preventDefault();
            $(panzoomSelector).panzoom("pan", 10, 0, { relative: true });
            break;
        case RIGHTKEY:
            e.preventDefault();
            $(panzoomSelector).panzoom("pan", -10, 0, { relative: true });
            break;
    }

}

function attachSizedEvents(e) {
    const currentWidth = window.innerWidth;

    if (currentWidth < this.largeBreakpoint) {
        // Do small browser stuff

        // grab clicks on element
        $(`${this.relatedLocation} .js-zoom-product-image`).on('click', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            activateZoomMode.bind(this)(event);
        });

        // Grab clicks on open guy in the corner, open zoom mode
        $(`${this.relatedLocation} .js-shadow-zoom__open`).on('click', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            activateZoomMode.bind(this)(event);
        });
    } else {
        // Do Large Browser stuff
        $(document).on({
            mouseenter: largeZoomStart,
            mouseleave: largeZoomEnd
        }, '.js-zoom-product-image');
    }
}

function detachSizedEvents() {
    $(`${this.relatedLocation} .js-zoom-product-image`).off('click');
    $(`${this.relatedLocation} .js-shadow-zoom__open`).off('click');
    $(document).off({
        mouseenter: largeZoomStart,
        mouseleave: largeZoomEnd
    }, '.js-zoom-product-image');
}

/**
 * Attach component events to DOM
 * @param {object} store The store
 */
function attachEvents(store) {
    detachSizedEvents.bind(this)();
    attachKeyboardEvents.bind(this)();
    attachSizedEvents.bind(this)();
    initShadowZoom.bind(this)();

    unveilImages($(this.scopedSelector('.js-carousel-zoom__slide:first .js-lazy')));

    // Wait for image to load before trying to scale overlay
    $(`${this.relatedLocation} .js-zoom-product-image:visible`).load(() => {
        scaleOverlayImage.bind(this)();
    });

    $(window).resize((e) => {
        detachSizedEvents.bind(this)();
        attachKeyboardEvents.bind(this)();
        attachSizedEvents.bind(this)(e);
        scaleOverlayImage.bind(this)(e);
    });
}

function defaultZoomOptions() {
    return {
        contain: 'invert',
        maxScale: 4,
        minScale: 1,
        increment: 1,
        panOnlyWhenZoomed: true,
        cursor: 'default'
    };
}

export function init(store, overrides = {}) {
    const config = {
        attachEvents: attachEvents,
        name: 'productZoomComponent',
        template: template,
        templateLocation: '.dom-pdp .dom-main-product .dom-shadow-zoom',
        relatedLocation: '.dom-pdp .dom-main-product .js-main-carousel',
        afterRebind: attachEvents,
        largeBreakpoint: browserSizes.large,
        zoomOptions: defaultZoomOptions,
        store: store
    };

    return generate(config, store, overrides);
}
